import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { ConsignmentService } from '@app/services/consignment.service';
import { OrderHeadConsignmentItem, OrderHeadDeliveryGet, OrderHeadGet, OrderheadService } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-delivery',
    templateUrl: './order-head-delivery.component.html',
    styleUrls: ['./order-head-delivery.component.css'],
})
export class OrderHeadDeliveryComponent implements OnInit {
    @Input()
    public get?: OrderHeadGet;

    @Output()
    public requestRefresh = new EventEmitter<void>();

    public grid?: GridOptions;

    public delivery?: OrderHeadDeliveryGet;

    public consignments: OrderHeadConsignmentItem[] = [];

    constructor(
        private orderhead: OrderheadService,
        private consignment: ConsignmentService,
        private modal: ModalService,
    ) {}

    public readGrid() {
        if (!this.get) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_consignment_consignmentline_grid')
                .setLoadDataFunction({ method: 3556, parameters: () => this.delivery })
                .addToolbarButton({ name: 'consignment_confirm_delivery', text: 'consignment_confirm_delivery', translate: true, icon: 'fa-plus', cssClass: 'tt-button tt-button--success im-grid-btn-xs-r', func: this.confirmDelivery })
                .addToolbarButton({ name: 'consigment_consignmentline_delete_assignments', text: 'consigment_consignmentline_delete_assignments', translate: true, icon: 'fad fa-trash', cssClass: 'tt-button tt-button--danger im-grid-btn-xs-r', func: this.deleteSelectedConsignmentLineAssignments, disabled: this.canDeleteConsignmentLine })
                .addToolbarButton({ name: 'consignment_assign', text: 'consignment_assign', translate: true, cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', icon: 'fa-sync-alt', func: this.autoAssignConsignment });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private confirmDelivery = async () => {
        if (!this.delivery) return;

        const { statusid, validationcode, validationmessage } = await this.consignment.confirmDelivery(this.delivery);

        if ('' + validationcode !== '0') {
            this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: validationmessage });
        } else {
            this.requestRefresh.emit();
            this.loadConsignments();
        }

        this.readGrid();
    };

    private deleteSelectedConsignmentLineAssignments = async () => {
        const rows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        if (!this.get || rows.length === 0) return;

        let value = 0;
        const progressDialog = this.modal.openProgressDialog({ value, max: rows.length, label: 'tt_deleting_consignment_lines', disableClose: true });

        for (let row of rows) {
            progressDialog.setLabel(`ID: ${row['consignmentline_keyno']}`, false);

            const { errorcode, errormessage } = await this.consignment.deleteLineAssignment({ consignmentline_keyno: row['consignmentline_keyno'] });

            if ('' + errorcode !== '0') {
                progressDialog.updateInvalidText(errormessage);
                progressDialog.updateStatus('invalid');
                break;
            } else {
                value = value + 1;
                progressDialog.updateValue(value);
            }
        }

        progressDialog.dialogRef.disableClose = false;

        if (value === rows.length) {
            progressDialog.updateStatus('finish');
        }

        this.readGrid();
    };

    private autoAssignConsignment = async () => {
        if (!this.get || !this.delivery) return;

        const { errorcode, errormessage } = await this.consignment.assign(this.delivery);

        if ('' + errorcode !== '0') {
            this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
        }

        this.readGrid();
    };

    private canDeleteConsignmentLine = async () => (this.grid?.gridfunc?.getIsSelectedRows() ?? []).filter((row) => [0, '0', false, 'false'].includes(row['is_selected'])).length === 0;

    private async loadDelivery() {
        if (!this.get) return;

        this.delivery = await this.orderhead.getOrderHeadDelivery({ order_internal_no: this.get.order_internal_no });
    }

    private async loadConsignments() {
        if (!!this.delivery) {
            this.consignments = await this.orderhead.getConsignments(this.delivery);
        }
    }

    private async init() {
        await this.loadDelivery();
        this.loadConsignments();
        this.readGrid();
    }

    ngOnInit(): void {
        this.init();
    }
}
